import styles from './styles.module.scss';
import { Skeleton } from 'components-antd';

type CardPropsType = {
  heading: string;
  count: number;
  color: string;
  clickHandler: Function;
  loading: boolean;
};

const Card = (props: CardPropsType) => {
  const { heading, count, color, clickHandler, loading } = props;

  return (
    <div
      className={styles.card}
      style={{
        background: color,
        cursor: count ? 'pointer' : 'default',
        pointerEvents: count ? 'auto' : 'none',
      }}
      onClick={() => clickHandler()}
    >
      <div className={styles.heading}>{heading}</div>
      <Skeleton showSkeleton={loading} rowCount={1}>
        <div className={styles.count}>{count}</div>
      </Skeleton>
    </div>
  );
};

export default Card;
